export default __webpack_public_path__ + "static/media/hero-bg.3b5f7a25.png";